
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from '../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect , handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    checkStateCustomerBrokerSelect: "[checkStateCustomerBrokerSelect] Action",
    checkStateCustomerBrokerSelectAsync: "[checkStateCustomerBrokerSelectAsync] Action",
    checkStateCustomerBrokerRemove: "[checkStateCustomerBrokerRemove] Action",
    checkStateCustomerBrokerLoading: "[checkStateCustomerBrokerLoading] Action",
    
};

const initialState = {
    exist: null,
    loading:false,
};


export const select_check_state_customer_broker_reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.checkStateCustomerBrokerSelect:
            return {
                ...state,
                exist: payload,
            }
            case actionTypes.checkStateCustomerBrokerLoading:
            return {
                ...state,
                loading: payload,
            }
            case actionTypes.checkStateCustomerBrokerRemove:
                return initialState
            default:
                return state
    }
}

function* handleWorker({ payload }) {
    
    yield put({ type: actionTypes.checkStateCustomerBrokerLoading, payload:true })
    let config = {
        url: "select_request",
        "token": "3cf61fab-b50a-410f-9d59-3357ee4706fe",
        "member_id": "_0zehXYBdxxYGfkX5_wd",
    }

    let data = {
        table: "brokercustomer",
        method_type: "check_state_customer",
        data: payload?.data ? payload?.data : {}
    } 


    try {
        let res = yield axiosCustom(config, data)

        let isOk = handleNotificationAlertTrySelect(res)
        if (!isOk) return

        yield put({ type: actionTypes.checkStateCustomerBrokerSelect, payload: res?.data?.response?.data?.exist })


    } catch  {
        handleNotificationAlertCatch()
    }
    finally{
        yield put({ type: actionTypes.checkStateCustomerBrokerLoading, payload:false })
    }


}


export function*  select_check_state_customer_broker_worker () {

    yield takeLatest(actionTypes.checkStateCustomerBrokerSelectAsync, handleWorker)
}